import { Button } from '@/components/ui/button';
import { useDocumentMeta } from '@/lib/useDocumentMeta';

export default function CheckoutCancelPage() {
  useDocumentMeta({ title: 'Checkout Canceled — Cash Forth' });
  return (
    <div
      className="min-h-screen bg-white flex items-center justify-center px-6"
      data-testid="checkout-cancel-page"
    >
      <div className="max-w-md w-full text-center">
        <h1 className="font-heading text-2xl sm:text-3xl font-semibold tracking-tight text-black">
          Checkout canceled.
        </h1>
        <p className="mt-3 text-sm text-gray-600">
          Your subscription was not started. You can return to Cash Forth and try again whenever you're ready.
        </p>
        <div className="mt-8">
          <Button
            onClick={() => { window.location.href = '/app'; }}
            data-testid="checkout-cancel-return-btn"
            className="bg-black text-white hover:bg-black/85 rounded-md px-6"
          >
            Return to Cash Forth
          </Button>
        </div>
      </div>
    </div>
  );
}
